import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from "react-dom";

import DNDPreviewLayerComponent from "core/gd-modules/dnd/preview-layer/dnd-preview-layer-component";
import ListItem from "../item/row";

export default class GenericListPreviewLayer extends DNDPreviewLayerComponent {

    static propTypes = {
        module: PropTypes.object
    }

    showPreview(source, mouseEvent) {
        this.initialPreviewSourceRect = source.getInitialRect();

        this.setState({
            source: source
        }, ()=>{
            this.onItemUpdate();
        });
    }

    onItemUpdate = () => {
        this.previewNode = findDOMNode(this.preview);
        this.updatePreview();
    }

    hidePreview() {
        this.initialPreviewSourceRect = null;
        this.previewNode = null;

        this.setState({
            source: null
        });
    }

    updatePreview(dx = 0, dy = 0) {
        if (!this.initialPreviewSourceRect) return;

        this.previewNode.style.setProperty("position", "absolute");
        this.previewNode.style.setProperty("left", (this.initialPreviewSourceRect.left/* + dx*/) + "px");
        this.previewNode.style.setProperty("top", (this.initialPreviewSourceRect.top + dy) + "px");
    }

    renderItem() {
        return (
            <div ref={r=>this.preview = r} className={Classes("ui5-glist-group", "is-drag-preview")} style={{width: this.props.module.columns.getCombinedWidth()}}>
                <ListItem module={this.props.module} data={this.state.source.props.data}/>
            </div>
        )
    }

    render() {
        if (!this.state.source) return null;

        return (
            <div className="ui5-glist-preview-layer">
                {this.renderItem()}
            </div>
        );
    }
}
